import Heading from 'LuxKit/Typography/Heading'
import { TOUR_V2_BOOK_WITH_CONFIDENCE_ITEMS } from 'constants/tours'
import React from 'react'
import TourV2BookWithConfidenceItem from './TourV2BookWithConfidenceItem'
import Group from 'components/utils/Group'

function TourV2BookWithConfidence() {
  return (
    <Group direction="vertical" gap={16}>
      <Heading variant="heading3" align="center">Book with confidence</Heading>
      <Group direction="vertical" gap={24} desktopDirection="horizontal" desktopGap={0}>
        {TOUR_V2_BOOK_WITH_CONFIDENCE_ITEMS.map(item => (
          <TourV2BookWithConfidenceItem
            key={item.title}
            {...item}
          />
        ))}
      </Group>
    </Group>
  )
}

export default TourV2BookWithConfidence
